/**
 * @prettier
 * @flow
 */
import { makeStyles } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import * as React from 'react';
import { useFormContext } from 'react-hook-form';

export function FormSubmitButton({ text, disabled }: Props): React.Node {
    const classes = useStyles();
    const {
        formState: { isSubmitting },
    } = useFormContext();
    return (
        <Button variant='contained' color='primary' type='submit' disabled={disabled || isSubmitting}>
            {isSubmitting && <CircularProgress color='primary' size={30} className={classes.buttonProgress} />}
            {text}
        </Button>
    );
}

const useStyles = makeStyles(theme => ({
    buttonProgress: {
        position: 'absolute',
    },
}));

type Props = {
    text: string,
    disabled?: boolean,
};
